export const benefits = [
  "Access to paywall stories",
  "Access to NL Chatbox",
  "Access to our subscriber-only Discord server",
  "Access to subscriber-only events, including The Media Rumble and NL Recess",
  "Access to podcast RSS links to listen to our paywall podcasts in apps like Apple and Google Podcasts",
  "Access to NL Baithak"
];

export const GROUPS = [
  {
    id: 114,
    name: "Disruptor",
    plans: [
      {
        id: 338,
        name: "Monthly",
        price: 300
      },
      {
        id: 339,
        name: "Half Yearly",
        price: 1500
      },
      {
        id: 340,
        name: "Annual",
        price: 3000
      }
    ],
    trialPlans: [
      {
        id: 1149,
        name: "Monthly",
        price: 300
      }
    ]
  },
  {
    id: 113,
    name: "Game Changer",
    plans: [
      {
        id: 341,
        name: "Monthly",
        price: 1000
      },
      {
        id: 342,
        name: "Half Yearly",
        price: 5000
      },
      {
        id: 343,
        name: "Annual",
        price: 10000
      }
    ]
  }
];
